import React from 'react';
import { X, User, Skull, Search, MapPin } from 'lucide-react';

export const DetailModal = ({ data, currentTheme, onClose }) => {
  if (!data) return null;

  return (
    <div
      className="absolute inset-0 bg-black/60 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 border-2 rounded-lg p-6 max-w-md w-full mx-4 shadow-2xl"
        style={{ borderColor: currentTheme.accent }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            {data.type === 'suspect' && (
              data.isVictim ? (
                <div className="p-2 rounded-lg bg-red-900">
                  <Skull className="w-5 h-5 text-red-400" />
                </div>
              ) : (
                <div className="p-2 rounded-lg bg-slate-700">
                  <User className="w-5 h-5 text-slate-400" />
                </div>
              )
            )}
            {data.type === 'clue' && (
              <div className="p-2 rounded-lg bg-yellow-900">
                <Search className="w-5 h-5 text-yellow-400" />
              </div>
            )}
            {data.type === 'location' && (
              <div className="p-2 rounded-lg bg-blue-900">
                <MapPin className="w-5 h-5 text-blue-400" />
              </div>
            )}
            <div>
              <h3 className="text-lg font-bold text-white">{data.name}</h3>
              {data.type === 'suspect' && data.isVictim && (
                <span className="text-xs text-red-400 font-semibold">VICTIM</span>
              )}
              {data.type === 'clue' && (
                <span className="text-xs text-yellow-400 uppercase">{data.clueType}</span>
              )}
              {data.type === 'location' && (
                <span className="text-xs text-blue-400 uppercase">Location</span>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-slate-700 text-gray-400 hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Image for suspects */}
        {data.type === 'suspect' && data.image && (
          <div className="mb-4 flex justify-center">
            <img
              src={data.image}
              alt={data.name}
              className="w-24 h-24 rounded-full object-cover border-2"
              style={{ borderColor: data.isVictim ? '#ef4444' : currentTheme.accent }}
            />
          </div>
        )}

        {/* Content */}
        <div className="space-y-3 text-sm">
          {data.occupation && (
            <div>
              <span className="text-gray-400">Occupation:</span>
              <p className="text-white">{data.occupation}</p>
            </div>
          )}
          {data.relationship && (
            <div>
              <span className="text-gray-400">Relationship to Victim:</span>
              <p className="text-white">{data.relationship}</p>
            </div>
          )}
          {data.background && (
            <div>
              <span className="text-gray-400">Background:</span>
              <p className="text-white">{data.background}</p>
            </div>
          )}
          {data.alibi && (
            <div>
              <span className="text-gray-400">Alibi:</span>
              <p className="text-white">{data.alibi}</p>
            </div>
          )}
          {data.description && (
            <div>
              <span className="text-gray-400">Description:</span>
              <p className="text-white">{data.description}</p>
            </div>
          )}
          {data.location && (
            <div>
              <span className="text-gray-400">Found at:</span>
              <p className="text-white">{data.location}</p>
            </div>
          )}
          {data.significance && (
            <div>
              <span className="text-gray-400">Significance:</span>
              <p className="text-white">{data.significance}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
